import moment from "moment";

export const findExpireDays = (expiryDate) => {
  let today = moment().format("DD-MM-YY");
  let startDateArray = today.split("-");
  let endDateArray = expiryDate.split("/");

  let startYear = 2000 + parseInt(startDateArray[2]);
  let startMonth = parseInt(startDateArray[1]) - 1; //
  let startDay = parseInt(startDateArray[0]);

  let endYear = 2000 + parseInt(endDateArray[2]);
  let endMonth = parseInt(endDateArray[1]) - 1;
  let endDay = parseInt(endDateArray[0]);

  let startDate = new Date(startYear, startMonth, startDay);
  let endDate = new Date(endYear, endMonth, endDay);
 console.log(startDate.getTime())
 console.log(endDate.getTime())
 console.log(endDate.getTime() - startDate.getTime())

  let timeDifference = endDate.getTime() - startDate.getTime();
  let difference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  console.log('diff', difference)

  return difference;
  // return 3;
};
